document.addEventListener("DOMContentLoaded", function() {
    setTimeout(() => {
        var customerTags = (BSS_B2B && BSS_B2B.shopData && BSS_B2B.shopData.customer) 
            ? BSS_B2B.shopData.customer.tags 
            : [];

        console.log('customerTags', customerTags);

        if (customerTags && customerTags.includes("Wholesale")) {
            // Hide Seal Subscriptions widget
            var sealWidget = document.querySelector(".sealsubs-target-element"); 
            console.log('sealWidget', sealWidget);
            if (sealWidget) {
                sealWidget.style.display = "none";
            }

            // Disable subscription buttons
            var subscribeButtons = document.querySelectorAll(".seal-subscribe-button");
            

            subscribeButtons.forEach(function(button) {
                button.disabled = true;
                button.style.display = "none"; // hoặc button.style.pointerEvents = "none";
            });
        }
    }, 1000);
});

